import './team-section.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function initTeamSection() {
	const roots = document.querySelectorAll( '[data-component="team-section"]' );

	if ( ! roots.length ) {
		return;
	}

	roots.forEach( ( root ) => {
		const bg = root.querySelector( '.b-teamSection__bg' );

		if ( ! bg ) {
			return;
		}

		const mm = gsap.matchMedia();

		mm.add( '(min-width: 768px)', () => {
			ScrollTrigger.create( {
				trigger: root,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
				animation: gsap.to( bg, {
					scale: 1.2,
					yPercent: 15,
					ease: 'none',
				} ),
			} );
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initTeamSection );
} else {
	initTeamSection();
}
